import { getTextWithDigit } from '../utils/index';
import FindReplaceBlot from '../quill/findReplaceEmbed';

export default {
  data() {
    return {
      matchesCache: [],
    };
  },
  methods: {
    // 对特殊字符进行转义
    escapeRegExp(text) {
      return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    findAll(text) {
      if (!text) return;
      // 1. 匹配
      const totalText = getTextWithDigit(this.quill);
      const reg = new RegExp(this.escapeRegExp(text), 'gi');
      let match;
      let matches = [];
      while ((match = reg.exec(totalText)) !== null) {
        matches.push({ match: match[0], index: match.index });
      }

      // 2. 标记
      matches.forEach((item) => {
        item.format = this.quill.getFormat(item.index, 1);
        this.quill.formatText(
          item.index,
          text.length,
          FindReplaceBlot.blotName,
          true,
          'silent',
        );
      });

      this.matchesCache = matches.map((item, index) => ({
        index,
        id: this.id,
        coord: item.index,
        text: item.match,
        format: item.format,
      }));
      return this.matchesCache;
    },
    // 查找某一个
    findOne(index) {
      this.clearChooseStatus();
      const matchElements = this.$el.querySelectorAll(
        `.${FindReplaceBlot.className}`,
      );
      const curElement = matchElements[index];
      // TODO: 重复问题的处理
      // 确保dom已更新
      setTimeout(() => {
        curElement?.classList.add('active');
        curElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 0);
    },
    replaceAll(replaceText) {
      // reverse() -> 从后往前替换，防止坐标变化引起定位不准
      this.matchesCache?.reverse().forEach((item, index) => {
        this.replaceOne(replaceText, item);
      });
    },
    replaceOne(replaceText, match) {
      const { coord, text, format } = match;
      this.quill.deleteText(coord, text.length, 'user');
      this.quill.insertText(coord, replaceText, format, 'user');
    },
    clearChooseStatus() {
      const allMatchElements = document.querySelectorAll(
        `.${FindReplaceBlot.className}`,
      );
      allMatchElements.forEach((item) => {
        item.classList.remove('active');
      });
    },
    clearMatches() {
      // 使用quill的方法清除更好，但是在低错中的替换清除时quill会报错，所以使用dom操作
      // this.quill.formatText(0, this.quill.getLength(), FindReplaceBlot.blotName, false, 'silent');
      const matchElements = this.$el.querySelectorAll(
        `.${FindReplaceBlot.className}`,
      );
      matchElements.forEach((item) => {
        item.outerHTML = item.innerHTML;
      });
    },
  },
};
